/** @jsxImportSource theme-ui */
import AssistantUsage from '@/containers/assistantUsage/AssistantUsage';

const AssistantUsagePage = () => <AssistantUsage />;

export default AssistantUsagePage;
